const requireContext = require.context('~/assets/images/svg', false, /\.svg$/);

// 注册所有 SVG 文件
requireContext.keys().forEach(requireContext);
